import React, { Fragment, useState, useContext, useEffect } from "react";
import "./Styles.css";
import { LangCtx, PayLoadCtx, CustomCtx } from "../../lib/context";
import { langObj } from "../../locale/index";
import DropDown from "../../lib/ui/dropdown/Dropdown";
import PlayCircleFilledWhiteIcon from "@mui/icons-material/PlayCircleFilledWhite";
import { getDomainDetials } from "../../actions/users";
import UserMenuPopover from "./UserMenuPopover";

const Header = (props) => {
    const [logo, setLogo] = useState(null);
    const { l, setLang } = useContext(LangCtx);
    const { payload } = useContext(PayLoadCtx);
    const { custom } = useContext(CustomCtx);

    const isPatient = props.role === "P" || props.role === "patient" || props.role === "Patient";

    const getDetails = () => {
        getDomainDetials(custom.subDomain)
            .then((res) => {
                if (res.status) {
                    if (res.data != null) {
                        // The domain API returns `data` as a single object now
                        // (was an array). Support both so it can't throw on
                        // `data[0]` being undefined.
                        const domain = Array.isArray(res.data) ? res.data[0] : res.data;
                        setLogo(domain?.logo);
                    }
                }
            })
            .catch((err) => {
                console.log("err ==== ", err);
            });
    };

    useEffect(() => {
        getDetails();
    }, [custom.logo]);

    const handleLang = (e) => {
        setLang(langObj[e.target.value]);
        localStorage.setItem("lang", e.target.value);
    };
    const langOptions = [
        { value: "en", label: l.english },
        { value: "hi", label: l.hindi },
        { value: "fr", label: l.french },
    ];
    let name = payload?.consultRole && payload.consultRole === "doctor" ? "Dr. " : "";
    name += payload?.firstName ? payload.firstName : "";
    name += payload?.lastName ? " " + payload.lastName : "";
    name = payload?.consultRole === "clinic" ? payload?.clinicName : name;
    return (
        <Fragment>
            <div className="appBar">
                {!isPatient && (
                    <div className="appIconBox" onClick={props.handleSlide}>
                        <span></span>
                        <span></span>
                        <span></span>
                    </div>
                )}
                <div className="brandingBox">
                    <div className="logoBox">
                        <img src={logo && logo !== "" ? logo : custom.logo} alt="logo" />
                    </div>
                </div>
                {custom?.subDomain === process.env.REACT_APP_subdomain && (
                    <div className="callBtn">
                        <a
                            className="tollfree flexInline "
                            href="https://help.instavc.com/inclinic"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <PlayCircleFilledWhiteIcon className="callIcon" fontSize="small" />
                            {l.help_center}
                        </a>
                    </div>
                )}
                {/* <div className="innerLangBlock">
                <DropDown placeholder="Languages" items={langOptions} value={localStorage.getItem('lang') ?localStorage.getItem('lang'): l.locale || 'en'} onChange={handleLang} />
            </div> */}
                <div className="flexAutoRow pdngHXSM">
                    <DropDown
                        placeholder="Languages"
                        items={langOptions}
                        value={localStorage.getItem("lang") ? localStorage.getItem("lang") : l.locale || "en"}
                        onChange={handleLang}
                    />
                </div>
                <div className="webAppBarAction">
                    <div className="flexAutoCol prfName pdngHXSM">
                        <span className="wlcomText">{l.welcome}</span>
                        <small className="primaryTxt ellipsisTxt txtAlignEnd">{name}</small>
                    </div>
                    <UserMenuPopover handleLogout={props.handleLogout} />
                </div>
            </div>
        </Fragment>
    );
};
export default Header;
